// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2296":"1ae9c890","3799":"1ae9c890","4364":"e18a9a6a","5910":"1ae9c890","8615":"1ae9c890","9835":"1ae9c890"}[chunkId] + ".chunk.css";
};